import React, { useEffect, useState } from "react";
import "./slider.scss";
export const Slider = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    minValue,
    maxValue,
    currentMin,
    currentMax,
    step = 1,
    onChange,
    minValueLabel,
    maxValueLabel,
    idPrefix,
    onEnd
  } = _ref;
  const [sliderMinValue, setSliderMinValue] = useState(currentMin || minValue);
  const [sliderMaxValue, setSliderMaxValue] = useState(currentMax || maxValue);
  const [zIndexMaxValueElement, setZIndexMaxValueElement] = useState(3);
  const [zIndexMinValueElement, setZIndexMinValueElement] = useState(5);
  useEffect(() => {
    currentMin && setSliderMinValue(currentMin);
    currentMax && setSliderMaxValue(currentMax);
  }, [currentMin, currentMax]);
  const sliderRange = Array.from({
    length: maxValue
  }, (_, index) => index + minValue);
  const setZIndex = element => {
    if (element === "min") {
      setZIndexMinValueElement(zIndexMaxValueElement);
      setZIndexMaxValueElement(zIndexMinValueElement);
    } else if (element === "max") {
      setZIndexMaxValueElement(zIndexMinValueElement);
      setZIndexMinValueElement(zIndexMaxValueElement);
    }
  };
  const handleMinSliderChange = event => {
    const newValue = parseInt(event.target.value, 10);
    if (newValue <= sliderMaxValue) {
      setSliderMinValue(newValue);
      onChange(newValue, sliderMaxValue);
    }
  };
  const handleMaxSliderChange = event => {
    const newValue = parseInt(event.target.value, 10);
    if (newValue >= sliderMinValue) {
      setSliderMaxValue(newValue);
      onChange(sliderMinValue, newValue);
    }
  };
  const calculateRangeWidth = () => {
    const range = sliderMaxValue - sliderMinValue;
    const totalRange = maxValue - minValue;
    return "".concat(range / totalRange * 100, "%");
  };
  const calculateMargin = () => {
    return "".concat((sliderMinValue - minValue) / (maxValue - minValue) * 100, "%");
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "slider-container",
    ref: ref
  }, /*#__PURE__*/React.createElement("input", {
    id: "".concat(idPrefix || "", "filter-min-value"),
    className: "thumb right",
    type: "range",
    min: minValue,
    max: maxValue,
    step: step,
    value: sliderMinValue,
    onChange: handleMinSliderChange,
    onMouseDown: () => setZIndex("min"),
    style: {
      zIndex: zIndexMinValueElement
    },
    onMouseUp: () => onEnd && onEnd(),
    onKeyUp: e => onEnd && ["ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight"].includes(e.key) && onEnd()
  }), /*#__PURE__*/React.createElement("input", {
    id: "".concat(idPrefix || "", "filter-max-value"),
    className: "thumb left",
    type: "range",
    min: minValue,
    max: maxValue,
    step: step,
    value: sliderMaxValue,
    onChange: handleMaxSliderChange,
    onMouseDown: () => setZIndex("max"),
    style: {
      zIndex: zIndexMaxValueElement
    },
    onMouseUp: () => onEnd && onEnd(),
    onKeyUp: e => onEnd && ["ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight"].includes(e.key) && onEnd()
  }), /*#__PURE__*/React.createElement("div", {
    className: "slider"
  }, /*#__PURE__*/React.createElement("div", {
    className: "slider-track"
  }), /*#__PURE__*/React.createElement("div", {
    className: "slider-range",
    style: {
      width: calculateRangeWidth(),
      marginLeft: calculateMargin()
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "slider-values"
  }, sliderRange.map(value => /*#__PURE__*/React.createElement("span", {
    key: value
  }, value))), /*#__PURE__*/React.createElement("label", {
    htmlFor: "".concat(idPrefix || "", "filter-min-value"),
    className: "slider-left-value"
  }, minValueLabel), /*#__PURE__*/React.createElement("label", {
    htmlFor: "".concat(idPrefix || "", "filter-max-value"),
    className: "slider-right-value"
  }, maxValueLabel)));
});